import { config } from '~state/store/config'

export const { useGetConfigQuery } = config
